import React from 'react';
import {Provider} from 'react-redux';
import {applyMiddleware, createStore} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import {BrowserRouter, Route, useHistory, useLocation} from 'react-router-dom';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import reducer from './reducers';

import momentZ from 'moment-timezone';
import Main from "./components/main";

momentZ.tz.setDefault('UTC');

const routsTemplates: any = {
  'default': [
    {path: '/', component: Main, order: 0},
  ]
};

const HandlerLocation = ({routs}: {routs: any[]}) => {
  const history = useHistory();
  const location = useLocation();

  if (routs.length !== 0 && location.pathname === '/' && routs[0].path !== '/') {
    history.push(routs[0].path);
  }
  return null;
};

const store = createStore(
    reducer,
    composeWithDevTools(applyMiddleware(createDebounce(),thunk)),
);

const WithProvider = () => {
  let routs: any[] = routsTemplates['default'];

  return <Provider store={store}>
    <BrowserRouter>
      <div  className="app-container">
        <HandlerLocation
            routs={routs}
        />
        <div className={'body-container'}>
          {
            routs.map((rout) => {
              // eslint-disable-next-line react/jsx-key
              return <Route exact path={rout.path} component={rout.component}/>;
            })
          }
        </div>
      </div>
    </BrowserRouter>
  </Provider>;
};

export default WithProvider;
